import React, { useState } from 'react';
import { SnapshotUrl, Terminal } from 'types/Shipping';
import { Tab, Tabs, Typography } from '@mui/material';
import { TabContent } from './TabContent';

interface Props {
  snapshotUrls?: SnapshotUrl[];
  ports: Terminal[];
}

export const TerminalTabs: React.FC<Props> = (props) => {
  const { snapshotUrls, ports } = props;

  const tabs = React.useMemo(
    () =>
      snapshotUrls
        ? snapshotUrls.map(({ terminal }) => {
            const port = ports.find(({ key }) => key === terminal);
            const { pier } = port || {};
            return {
              key: terminal,
              pier,
            };
          })
        : [],
    [snapshotUrls, ports]
  );

  const [selectedTab, setSelectedTab] = useState(tabs[0]?.key);
  React.useEffect(() => {
    setSelectedTab(tabs[0]?.key);
  }, [tabs]);

  if (snapshotUrls?.length === 0 || ports.length === 0) return null;

  return (
    <div>
      <Tabs value={selectedTab} onChange={(_, value) => setSelectedTab(value)}>
        {tabs.map(({ key, pier }) => (
          <Tab key={key} disableRipple label={<Typography>{pier}</Typography>} value={key} />
        ))}
      </Tabs>
      <TabContent
        key={selectedTab}
        snapshotUrl={snapshotUrls?.find((s) => s.terminal === selectedTab)}
        terminal={ports.find((p) => p.key === selectedTab)}
      />
    </div>
  );
};
